import React from "react";
import { Heading } from "spectacle";

export const S40 = () => <Heading size={1}>Why TypeScript?</Heading>;
